import React, { useEffect, useState } from "react";
import "../../styles/sidebar.css";
import api from "../../config/URL";
import { toast } from "react-toastify";
import fetchAllCentersWithIds from "../List/CenterList";
import ReplacementAdd from "./ReplacementAdd";
import { Link } from "react-router-dom";
import { format, parse } from "date-fns";
import CustomDatePicker from "../CustomDatePicker";
import { useFormik } from "formik";
import * as Yup from "yup";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { MdAdd } from "react-icons/md";
import fetchAllCoursesWithIdsC from "../List/CourseListByCenter";
import WebSocketService from "../../config/WebSocketService";
import { AiOutlineFilePdf } from "react-icons/ai";
import fetchAllTeacherListByCenter from "../List/TeacherListByCenter"; // ✅ make sure this import exists

// New component for each accordion item
const AttendanceItem = ({
  attendanceItem,
  attendanceIndex,
  lessonData,
  fetchData,
  selectedDate,
  storedScreens,
  handleAttendanceChange,
  handleRemarksChange,
  handleTemplateMessageChange,
  handleSubmit,
  handleReplacementSuccess,
  submittingIndex,
}) => {
  const formik = useFormik({
    initialValues: {
      items: attendanceItem.feedbacks?.length
        ? attendanceItem.feedbacks
        : [
            {
              lessonNo: "",
              curriculumCode: "",
              nextClassAdvice: "",
              curriculumId: "",
              pace: "",
            },
          ],
    },
    validationSchema: Yup.object().shape({
      items: Yup.array().of(
        Yup.object().shape({
          lessonNo: Yup.string().required("*Lesson number is required"),
          curriculumCode: Yup.string().required("*Curriculum code is required"),
          nextClassAdvice: Yup.string().required(
            "*Next class advice is required",
          ),
        }),
      ),
    }),
    onSubmit: async (values) => {
      try {
        const additionalValues = {
          attendanceDate: format(selectedDate, "yyyy-MM-dd"),
          batchTime: attendanceItem.batchTime,
          userId: attendanceItem.userId,
        };

        const payload = values.items.map((item) => ({
          ...item,
          ...additionalValues,
        }));
        const response = await api.post(`createFeedbackAttendances`, payload);
        if (response.status === 201) {
          toast.success(response.data.message);
          fetchData();
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        toast.error("Error Creating Data ", error?.response?.data?.message);
      }
    },
  });

  const [messageTemplates, setMessageTemplates] = useState({
    present: "",
    absent: "",
  });

  const handleDelete = async (id, index) => {
    if (!id) {
      const updatedItems = [...formik.values.items];
      updatedItems.splice(index, 1);
      formik.setFieldValue("items", updatedItems);
      return;
    }

    try {
      const response = await api.delete(`deleteFeedbackAttendance/${id}`);
      if (response.status === 201) {
        toast.success("Feedback removed successfully!");
        const updatedItems = [...formik.values.items];
        updatedItems.splice(index, 1);
        formik.setFieldValue("items", updatedItems);
      } else {
        toast.error("Error removing feedback!");
      }
    } catch (error) {
      toast.error("Error removing feedback ", error?.response?.data?.message);
    }
  };

  const formatTo12Hour = (time) => {
    const [hours, minutes] = time.split(":");
    let period = "AM";
    let hour = parseInt(hours, 10);

    if (hour === 0) {
      hour = 12;
    } else if (hour >= 12) {
      period = "PM";
      if (hour > 12) hour -= 12;
    }

    return `${hour}:${minutes} ${period}`;
  };

  useEffect(() => {
    const fetchCurriculumCodesAndMessages = async () => {
      const curriculumIds = formik.values.items
        .filter((item) => item.lessonNo !== "")
        .map((item) => item.lessonNo)
        .join(",");

      if (!curriculumIds) return;

      try {
        const messageResponse = await api.get(
          `getAttendanceMessageByCurriculumId?ids=${curriculumIds}`,
        );

        const newTemplates = {
          present: messageResponse.data.present || "",
          absent: messageResponse.data.absent || "",
        };

        setMessageTemplates(newTemplates);

        attendanceItem.students.forEach((student, studentIndex) => {
          if (
            student.attendance === "present" ||
            student.attendance === "absent"
          ) {
            handleTemplateMessageChange(
              attendanceIndex,
              studentIndex,
              newTemplates[student.attendance],
            );
          }
        });

        await Promise.all(
          formik.values.items.map(async (item, index) => {
            if (!item.lessonNo) return;

            const response = await api.get(`curriculumCode/${item.lessonNo}`);

            formik.setFieldValue(
              `items[${index}].curriculumCode`,
              response.data.curriculumCode || "",
            );

            formik.setFieldValue(`items[${index}].curriculumId`, item.lessonNo);
          }),
        );
      } catch (error) {
        toast.error("Error fetching lesson messages");
      }
    };

    fetchCurriculumCodesAndMessages();
  }, [formik.values.items]);

  return (
    <div className="accordion py-2" id={`accordionExample-${attendanceIndex}`}>
      <div className="accordion-item">
        <h2 className="accordion-header" style={{ marginBottom: "0px" }}>
          <button
            className="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            style={{ padding: "0 10px" }}
            data-bs-target={`#flush-collapse-${attendanceIndex}`}
            aria-expanded="false"
            aria-controls={`flush-collapse-${attendanceIndex}`}
          >
            <div
              className="table d-flex"
              id="acordeanHead"
              style={{ backgroundColor: "transparent" }}
            >
              <div style={{ width: "20%" }} className="pb-2 pt-4">
                <p style={{ marginBottom: "0px", paddingLeft: "10px" }}>
                  {attendanceItem.center}
                </p>
              </div>
              <div style={{ width: "20%" }} className="pb-2 pt-4">
                <p style={{ marginBottom: "0px", paddingLeft: "10px" }}>
                  {attendanceItem.course}
                </p>
              </div>
              <div style={{ width: "20%" }} className="pb-2 pt-4">
                <p style={{ marginBottom: "0px", paddingLeft: "10px" }}>
                  {attendanceItem.classCode}
                </p>
              </div>
              <div style={{ width: "20%" }} className="pb-2 pt-4">
                <p style={{ marginBottom: "0px", paddingLeft: "10px" }}>
                  {attendanceItem.batchTime
                    ? formatTo12Hour(attendanceItem.batchTime)
                    : "-"}
                </p>
              </div>
              <div style={{ width: "20%" }} className="pb-2 pt-4">
                <p style={{ marginBottom: "0px", paddingLeft: "10px" }}>
                  {attendanceItem.courseType}
                </p>
              </div>
              <div style={{ width: "20%" }} className="pb-2 pt-4">
                <p style={{ marginBottom: "0px", paddingLeft: "10px" }}>
                  {attendanceItem.classListingTeacher}
                </p>
              </div>
            </div>
          </button>
        </h2>
        <div
          id={`flush-collapse-${attendanceIndex}`}
          className="accordion-collapse collapse"
          data-bs-parent={`#accordionExample-${attendanceIndex}`}
        >
          <div className="accordion-body">
            <form onSubmit={formik.handleSubmit}>
              <div className="container">
                <span className="text-secondary fs-6 mb-2">Add Feedback</span>
                {formik.values.items.map((item, index) => (
                  <div key={index}>
                    <div className="row">
                      <div className="col-1 text-end d-flex justify-content-center align-items-start">
                        <button
                          type="button"
                          className="btn mt-2"
                          style={{ marginBottom: "5.0rem" }}
                          onClick={() => handleDelete(item.id, index)}
                        >
                          <IoIosCloseCircleOutline
                            style={{
                              fontSize: "1.5rem",
                              color: "red",
                              background: "none",
                            }}
                          />
                        </button>
                      </div>
                      <div className="col-md-3 col-6 mb-4">
                        <label className="form-label">
                          Lesson No<span className="text-danger">*</span>
                        </label>
                        <select
                          {...formik.getFieldProps(`items[${index}].lessonNo`)}
                          className={`form-select ${
                            formik.touched.items?.[index]?.lessonNo &&
                            formik.errors.items?.[index]?.lessonNo
                              ? "is-invalid"
                              : ""
                          }`}
                          aria-label="Default select example"
                        >
                          <option></option>
                          {lessonData[attendanceIndex] &&
                            lessonData[attendanceIndex].map((lesson) => (
                              <option key={lesson.id} value={lesson.id}>
                                {lesson.lessonNo}
                              </option>
                            ))}
                        </select>
                        {formik.touched.items?.[index]?.lessonNo &&
                        formik.errors.items?.[index]?.lessonNo ? (
                          <div className="invalid-feedback">
                            {formik.errors.items[index].lessonNo}
                          </div>
                        ) : null}
                      </div>
                      <div className="col-md-3 col-6 mb-4">
                        <label className="form-label">
                          Curriculum Code<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${
                            formik.touched.items?.[index]?.curriculumCode &&
                            formik.errors.items?.[index]?.curriculumCode
                              ? "is-invalid"
                              : ""
                          }`}
                          {...formik.getFieldProps(
                            `items[${index}].curriculumCode`,
                          )}
                          readOnly
                        />
                        {formik.touched.items?.[index]?.curriculumCode &&
                        formik.errors.items?.[index]?.curriculumCode ? (
                          <div className="invalid-feedback">
                            {formik.errors.items[index].curriculumCode}
                          </div>
                        ) : null}
                      </div>
                      <div
                        className={`col-md-3 col-6 mb-4 ${
                          formik.touched.items?.[index]?.nextClassAdvice &&
                          formik.errors.items?.[index]?.nextClassAdvice
                            ? "is-invalid"
                            : ""
                        }`}
                      >
                        <label className="form-label">
                          Next Class Advice
                          <span className="text-danger">*</span>
                        </label>
                        <div>
                          <input
                            type="radio"
                            id={`items[${index}].nextClassAdvice-competent-${attendanceIndex}`}
                            name={`items[${index}].nextClassAdvice`}
                            value="Competent"
                            checked={
                              formik.values.items[index]?.nextClassAdvice ===
                              "Competent"
                            }
                            onChange={formik.handleChange}
                            onBlur={() =>
                              formik.setFieldTouched(
                                `items[${index}].nextClassAdvice`,
                                true,
                              )
                            }
                            className="form-check-input"
                          />
                          &nbsp;&nbsp;
                          <label
                            className="form-check-label"
                            htmlFor={`items[${index}].nextClassAdvice-competent-${attendanceIndex}`}
                          >
                            Competent
                          </label>
                        </div>
                        <div>
                          <input
                            type="radio"
                            id={`items[${index}].nextClassAdvice-revision-${attendanceIndex}`}
                            name={`items[${index}].nextClassAdvice`}
                            value="Require Revision"
                            checked={
                              formik.values.items[index]?.nextClassAdvice ===
                              "Require Revision"
                            }
                            onChange={formik.handleChange}
                            onBlur={() =>
                              formik.setFieldTouched(
                                `items[${index}].nextClassAdvice`,
                                true,
                              )
                            }
                            className="form-check-input"
                          />
                          &nbsp;&nbsp;
                          <label
                            className="form-check-label"
                            htmlFor={`items[${index}].nextClassAdvice-revision-${attendanceIndex}`}
                          >
                            Require Revision
                          </label>
                        </div>
                        {formik.touched.items?.[index]?.nextClassAdvice &&
                        formik.errors.items?.[index]?.nextClassAdvice ? (
                          <div className="invalid-feedback d-block">
                            {formik.errors.items[index].nextClassAdvice}
                          </div>
                        ) : null}
                      </div>
                      <div className="col-md-2 col-6 mb-4">
                        <label className="form-label">Pace</label>
                        <div>
                          <input
                            type="radio"
                            id={`items[${index}].pace-fast-${attendanceIndex}`}
                            name={`items[${index}].pace`}
                            value="Fast (F)"
                            checked={
                              formik.values.items[index]?.pace === "Fast (F)"
                            }
                            onChange={formik.handleChange}
                            className={`form-check-input ${
                              formik.touched.items?.[index]?.pace &&
                              formik.errors.items?.[index]?.pace
                                ? "is-invalid"
                                : ""
                            }`}
                          />
                          &nbsp;&nbsp;
                          <label
                            className="form-check-label"
                            htmlFor={`items[${index}].pace-fast-${attendanceIndex}`}
                          >
                            Fast (F)
                          </label>
                        </div>
                        <div>
                          <input
                            type="radio"
                            id={`items[${index}].pace-normal-${attendanceIndex}`}
                            name={`items[${index}].pace`}
                            value="Normal (N)"
                            checked={
                              formik.values.items[index]?.pace === "Normal (N)"
                            }
                            onChange={formik.handleChange}
                            className={`form-check-input ${
                              formik.touched.items?.[index]?.pace &&
                              formik.errors.items?.[index]?.pace
                                ? "is-invalid"
                                : ""
                            }`}
                          />
                          &nbsp;&nbsp;
                          <label
                            className="form-check-label"
                            htmlFor={`items[${index}].pace-normal-${attendanceIndex}`}
                          >
                            Normal (N)
                          </label>
                        </div>
                        <div>
                          <input
                            type="radio"
                            id={`items[${index}].pace-slow-${attendanceIndex}`}
                            name={`items[${index}].pace`}
                            value="Slow (S)"
                            checked={
                              formik.values.items[index]?.pace === "Slow (S)"
                            }
                            onChange={formik.handleChange}
                            className={`form-check-input ${
                              formik.touched.items?.[index]?.pace &&
                              formik.errors.items?.[index]?.pace
                                ? "is-invalid"
                                : ""
                            }`}
                          />
                          &nbsp;&nbsp;
                          <label
                            className="form-check-label"
                            htmlFor={`items[${index}].pace-slow-${attendanceIndex}`}
                          >
                            Slow (S)
                          </label>
                        </div>
                        {formik.touched.items?.[index]?.pace &&
                        formik.errors.items?.[index]?.pace ? (
                          <div className="invalid-feedback">
                            {formik.errors.items[index].pace}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                ))}
                <div className="row mb-5">
                  <div className="col-12">
                    <button
                      type="button"
                      className="btn btn-sm text-white"
                      style={{ background: "#eb862a" }}
                      onClick={() =>
                        formik.setFieldValue("items", [
                          ...formik.values.items,
                          {
                            lessonNo: "",
                            curriculumCode: "",
                            nextClassAdvice: "",
                            pace: "",
                          },
                        ])
                      }
                    >
                      <MdAdd /> Add More
                    </button>
                  </div>
                </div>
              </div>
            </form>
            <div className="table-responsive mt-4">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Student Name</th>
                    <th className="text-start ps-3">Action</th>
                    <th>Remarks</th>
                    <th>Messages</th>
                  </tr>
                </thead>
                <tbody>
                  {attendanceItem.students.map((student, studentIndex) => (
                    <tr key={studentIndex}>
                      <th style={{ width: "15px" }} scope="row">
                        {studentIndex + 1}
                      </th>
                      <td>
                        <Link
                          to={`/student/view/${student.studentId}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {student.studentName || "-"}
                        </Link>
                        <br />
                        <span style={{ fontSize: "12px" }}>
                          {student.studentUniqueId || "-"}
                        </span>
                        <br />
                        <>
                          {student.documentHyperLink ? (
                            <a
                              href={student.documentHyperLink}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                textDecoration: "none",
                                cursor: "pointer",
                              }}
                            >
                              <AiOutlineFilePdf
                                size={19}
                                color="#d32f2f"
                                className="me-2"
                              />
                              + Document
                            </a>
                          ) : (
                            <span style={{ fontSize: "12px" }}>-</span>
                          )}
                        </>
                      </td>
                      <td>
                        <div>
                          {student.replacement ? (
                            <Link
                              className="text-decoration-none"
                              to={`/replaceclasslesson/view/${student.replacementId}`}
                            >
                              <span className="text-center">
                                Replacement Class Requested
                              </span>
                            </Link>
                          ) : (
                            <>
                              <label className="radio-button">
                                <input
                                  type="radio"
                                  name={`attendance-${attendanceIndex}-${studentIndex}`}
                                  value="present"
                                  checked={student.attendance === "present"}
                                  onChange={() => {
                                    handleAttendanceChange(
                                      attendanceIndex,
                                      studentIndex,
                                      "present",
                                      messageTemplates.present,
                                    );
                                  }}
                                />
                                <span className="radio-button-text">
                                  Present
                                </span>
                              </label>

                              <label className="radio-button">
                                <input
                                  type="radio"
                                  name={`attendance-${attendanceIndex}-${studentIndex}`}
                                  value="absent"
                                  checked={student.attendance === "absent"}
                                  onChange={() => {
                                    handleAttendanceChange(
                                      attendanceIndex,
                                      studentIndex,
                                      "absent",
                                      messageTemplates.absent,
                                    );
                                  }}
                                />
                                <span className="radio-button-text">
                                  Absent
                                </span>
                              </label>
                            </>
                          )}

                          {student.attendance === "absent" && (
                            <label>
                              <ReplacementAdd
                                selectedID={student.studentId}
                                attendanceData={attendanceItem}
                                attendanceDate={format(
                                  selectedDate,
                                  "yyyy-MM-dd",
                                )}
                                selectedStudent={student}
                                disabledButton={student.replacement}
                                buttonText={
                                  student.replacement
                                    ? "Already Replaced Class Lesson"
                                    : undefined
                                }
                                attendanceIndex={attendanceIndex}
                                studentIndex={studentIndex}
                                onReplacementSuccess={handleReplacementSuccess}
                                replacementLimitReached={
                                  student.replacementLimitReached
                                }
                                replacementUsedCount={
                                  student.replacementUsedCount
                                }
                                feedbackItems={attendanceItem.feedbacks || []}
                                userId={attendanceItem.userId}
                                centerId={attendanceItem.centerId}
                                classId={attendanceItem.classId}
                                courseId={attendanceItem.courseId}
                                batchTime={attendanceItem.batchTime}
                              />
                            </label>
                          )}
                        </div>
                      </td>
                      <td>
                        <input
                          type="text"
                          value={student.remarks || ""}
                          className="form-control"
                          onChange={(e) =>
                            handleRemarksChange(
                              attendanceIndex,
                              studentIndex,
                              e.target.value,
                            )
                          }
                        />
                      </td>
                      <td>
                        <textarea
                          rows="3"
                          type="text"
                          value={student.templateMessage || ""}
                          className="form-control"
                          onChange={(e) =>
                            handleTemplateMessageChange(
                              attendanceIndex,
                              studentIndex,
                              e.target.value,
                            )
                          }
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div>
              {storedScreens?.attendanceCreate && (
                <button
                  className="btn btn-button"
                  type="button"
                  onClick={() =>
                    handleSubmit(attendanceIndex, attendanceItem, formik)
                  }
                  disabled={attendanceItem.students.length === 0}
                >
                  {submittingIndex === attendanceIndex ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Submitting...
                    </>
                  ) : (
                    "Submit"
                  )}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

function Attendances({ selectedCenter }) {
  const userId = localStorage.getItem("userId");
  const role = localStorage.getItem("userName"); // ✅ role check
  const isTeacher = role === "SMS_TEACHER"; // ✅ boolean flag

  const [teacherData, setTeachereData] = useState(null);

  // ✅ filters state — includes userId
  const [filters, setFilters] = useState({
    userId: isTeacher ? userId : "", // ✅ auto-set if teacher role
  });

  const handleReplacementSuccess = (
    attendanceIndex,
    studentIndex,
    replacementId,
  ) => {
    setAttendanceData((prev) =>
      prev.map((item, aIdx) => {
        if (aIdx !== attendanceIndex) return item;

        return {
          ...item,
          students: item.students.map((student, sIdx) => {
            if (sIdx !== studentIndex) return student;

            return {
              ...student,
              replacement: true,
              replacementId,
              attendance: "replacement",
            };
          }),
        };
      }),
    );
  };

  const [attendanceData, setAttendanceData] = useState([]);
  const [centerData, setCenterData] = useState(null);
  const [courseData, setCourseData] = useState(null);
  const [center, setSelectedCenter] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedBatch, setSelectedBatch] = useState("");
  const storedScreens = JSON.parse(localStorage.getItem("screens") || "{}");
  const [batchData, setBatchData] = useState(null);
  const [lessonData, setLessonData] = useState({});
  const [messageTemplates, setMessageTemplates] = useState({
    present: "",
    absent: "",
  });

  const getCurrentDate = () => {
    const today = new Date();
    return today;
  };
  const [selectedDate, setSelectedDate] = useState(getCurrentDate());

  const formatDate = (date) => {
    if (!(date instanceof Date)) {
      date = new Date(date);
    }
    return format(date, "dd-MM-yyyy");
  };

  const fetchAvailableSlots = async (date) => {
    try {
      const formattedDate = formatDate(date);
      const response = await api.get(
        `getAvailableBatchTimings?attendanceDate=${formattedDate}`,
      );
      setBatchData(response.data);
    } catch (error) {
      toast.error("Error fetching slots:", error);
    }
  };

  const normalizeTime = (time) => {
    if (time.includes("AM") || time.includes("PM")) {
      return time;
    }
    const [hours, minutes] = time.split(":");
    let period = "AM";
    let hour = parseInt(hours, 10);

    if (hour === 0) {
      hour = 12;
    } else if (hour >= 12) {
      period = "PM";
      if (hour > 12) hour -= 12;
    }

    return `${hour}:${minutes} ${period}`;
  };

  const convertTo24Hour = (time) => {
    const [timePart, modifier] = time.split(" ");
    let [hours, minutes] = timePart.split(":").map(Number);

    if (modifier === "PM" && hours < 12) {
      hours += 12;
    } else if (modifier === "AM" && hours === 12) {
      hours = 0;
    }

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0",
    )}`;
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const fetchCentreData = async () => {
    try {
      const response = await fetchAllCentersWithIds();
      if (Array.isArray(response)) {
        setCenterData(response);
        setSelectedCenter(selectedCenter);
        fetchCourses(selectedCenter);
      } else {
        console.error("Invalid data format:", response);
        setCenterData([]);
      }
    } catch (error) {
      toast.error("Failed to fetch center data");
      console.error(error);
    }
  };

  const fetchCourses = async () => {
    try {
      if (selectedCenter) {
        const courseData = await fetchAllCoursesWithIdsC(selectedCenter);
        setCourseData(courseData);
      }
    } catch (error) {
      toast.error(error);
    }
  };

  // ✅ Fetch teacher list by center
  const fetchTeacherList = async (centerId) => {
    try {
      const teacherDatas = await fetchAllTeacherListByCenter(centerId);
      setTeachereData(teacherDatas);

      // ✅ If SMS_TEACHER role, auto-select matching teacher from list
      if (isTeacher && teacherDatas?.length) {
        const matched = teacherDatas.find(
          (t) => String(t.id) === String(userId),
        );
        if (matched) {
          setFilters((prev) => ({ ...prev, userId: String(matched.id) }));
        }
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const fetchData = async () => {
    try {
      const requestBody = {
        centerId: center,
        date: format(selectedDate, "yyyy-MM-dd"),
        courseId: selectedCourse || "",
        ...(selectedBatch && { batchTime: selectedBatch }),
        // ✅ pass userId filter to API — uses auto-set value for teacher role
        ...(filters.userId && { userId: filters.userId }),
      };
      const response = await api.post(
        "getAllTeacherWithStudentAttendance",
        requestBody,
      );
      setAttendanceData(response.data);
    } catch (error) {
      toast.error("Error fetching data:", error);
    }
  };

  const handleCenterChange = (event) => {
    const centerVal = event.target.value || selectedCenter;
    setCourseData([]);
    setSelectedCenter(centerVal);
    // ✅ fetch teacher list when center changes
    fetchTeacherList(centerVal);
    if (selectedCenter) {
      fetchCourses(selectedCenter);
    }
  };

  const getLessonData = async (courseId, attendanceIndex) => {
    try {
      const response = await api.get(`active/${courseId}`);
      setLessonData((prev) => ({
        ...prev,
        [attendanceIndex]: response.data,
      }));
    } catch (error) {
      toast.error("Error Fetching Data ", error?.response?.data?.message);
    }
  };

  // WebSocket subscription for attendance updates
  useEffect(() => {
    const handleAttendanceUpdate = (message) => {
      const { studentId, attendanceStatus, templateMessage } = message;
      setAttendanceData((prevData) =>
        prevData.map((attendanceItem) => ({
          ...attendanceItem,
          students: attendanceItem.students.map((student) => {
            if (student.studentId === studentId) {
              return {
                ...student,
                attendance: attendanceStatus,
                templateMessage:
                  templateMessage ||
                  (attendanceStatus === "present"
                    ? messageTemplates.present
                    : messageTemplates.absent),
              };
            }
            return student;
          }),
        })),
      );
      toast.info(
        `Attendance updated for student ${studentId}: ${attendanceStatus}`,
      );
    };

    WebSocketService.subscribeToAttendanceUpdates(handleAttendanceUpdate);

    return () => {};
  }, [messageTemplates]);

  useEffect(() => {
    if (selectedDate) {
      fetchAvailableSlots(selectedDate);
    }
  }, [selectedDate]);

  useEffect(() => {
    fetchCentreData();
    if (selectedCenter) {
      setSelectedCenter(selectedCenter);
      fetchTeacherList(selectedCenter); // ✅ load teachers on mount if center is already set
    }
  }, [selectedCenter]);

  useEffect(() => {
    attendanceData.forEach((item, index) => {
      if (item.courseId) {
        getLessonData(item.courseId, index);
      }
    });
  }, [attendanceData]);

  const handleAttendanceChange = (
    attendanceIndex,
    studentIndex,
    value,
    templateMessage,
  ) => {
    const updatedAttendanceData = [...attendanceData];
    updatedAttendanceData[attendanceIndex].students[studentIndex].attendance =
      value;
    updatedAttendanceData[attendanceIndex].students[
      studentIndex
    ].templateMessage = templateMessage;
    setAttendanceData(updatedAttendanceData);
  };

  const handleRemarksChange = (attendanceIndex, studentIndex, value) => {
    const updatedAttendanceData = [...attendanceData];
    updatedAttendanceData[attendanceIndex].students[studentIndex].remarks =
      value;
    setAttendanceData(updatedAttendanceData);
  };

  const handleTemplateMessageChange = (
    attendanceIndex,
    studentIndex,
    value,
  ) => {
    const updatedAttendanceData = [...attendanceData];
    updatedAttendanceData[attendanceIndex].students[
      studentIndex
    ].templateMessage = value;
    setAttendanceData(updatedAttendanceData);
  };

  const [submittingIndex, setSubmittingIndex] = useState(null);

  const handleSubmit = async (teacherIndex, attendanceItem, formik) => {
    try {
      setSubmittingIndex(teacherIndex);
      const errors = await formik.validateForm();

      formik.setTouched(
        formik.values.items.reduce((acc, _, index) => {
          acc.items = acc.items || [];
          acc.items[index] = {
            lessonNo: true,
            curriculumCode: true,
            nextClassAdvice: true,
          };
          return acc;
        }, {}),
      );

      if (Object.keys(errors).length > 0) {
        toast.error("Please complete all required feedback fields");
        return;
      }

      const hasFeedbackErrors =
        Object.keys(errors).length > 0 ||
        formik.values.items.some(
          (item) =>
            !item.lessonNo || !item.curriculumCode || !item.nextClassAdvice,
        );

      const hasFeedbackRows = formik.values.items.length > 0;

      let attendanceSubmitted = false;
      let feedbackSubmitted = false;

      const teacherAttendanceData = attendanceData[teacherIndex];
      const flattenedData = teacherAttendanceData.students
        .filter((student) => student.studentUniqueId)
        .map((student) => ({
          id: student.id,
          studentName: student.studentName,
          attendanceDate: format(selectedDate, "yyyy-MM-dd"),
          biometric: false,
          studentUniqueId: student.studentUniqueId,
          attendanceStatus: student.attendance,
          remarks: student.remarks || "",
          templateMessage: student.templateMessage || "",
          userId: attendanceItem.userId,
          studentId: student.studentId,
          centerId: attendanceItem.centerId,
          classId: attendanceItem.classId,
          courseId: attendanceItem.courseId,
          batchTime: attendanceItem.batchTime,
        }));

      const attendanceResponse = await api.post(
        "markStudentAttendance",
        flattenedData,
      );
      if (attendanceResponse.status === 201) {
        toast.success("Attendance marked successfully!");
        attendanceSubmitted = true;
      }

      if (hasFeedbackRows && !hasFeedbackErrors) {
        const additionalValues = {
          attendanceDate: format(selectedDate, "yyyy-MM-dd"),
          batchTime: attendanceItem.batchTime,
          userId: attendanceItem.userId,
        };

        const feedbackPayload = formik.values.items
          .filter(
            (item) =>
              item.lessonNo && item.curriculumCode && item.nextClassAdvice,
          )
          .map((item) => ({
            ...item,
            ...additionalValues,
            curriculumId: item.lessonNo,
          }));

        if (feedbackPayload.length > 0) {
          const feedbackResponse = await api.post(
            "createFeedbackAttendances",
            feedbackPayload,
          );
          if (feedbackResponse.status === 201) {
            toast.success("Feedback submitted successfully!");
            feedbackSubmitted = true;
          }
        }
      } else if (hasFeedbackRows && hasFeedbackErrors) {
        formik.setSubmitting(false);
        await formik.validateForm();
        formik.setTouched(
          formik.values.items.reduce((acc, _, index) => {
            acc[`items[${index}].lessonNo`] = true;
            acc[`items[${index}].curriculumCode`] = true;
            acc[`items[${index}].nextClassAdvice`] = true;
            return acc;
          }, {}),
        );
        toast.error(
          "Please fill all required feedback fields (Lesson No, Curriculum Code, Next Class Advice)",
        );
        return;
      }

      if (attendanceSubmitted) {
        fetchData();
        if (feedbackSubmitted) {
          toast.success("Attendance and Feedback both saved successfully!");
        }
      }
    } catch (error) {
      console.error("Submission error:", error);
      toast.error(
        error?.response?.data?.message ||
          "Failed to submit attendance or feedback",
      );
    } finally {
      setSubmittingIndex(null);
    }
  };

  return (
    <div className="container-fluid my-4 center">
      <ol
        className="breadcrumb my-3 px-1"
        style={{ listStyle: "none", padding: 0, margin: 0 }}
      >
        <li>
          <Link to="/" className="custom-breadcrumb">
            Home
          </Link>
          <span className="breadcrumb-separator"> &gt; </span>
        </li>
        <li>
          Student Management
          <span className="breadcrumb-separator"> &gt; </span>
        </li>
        <li className="breadcrumb-item active" aria-current="page">
          Attendance
        </li>
      </ol>
      <div className="card">
        <div
          className="mb-3 d-flex justify-content-between align-items-center p-1"
          style={{ background: "#f5f7f9" }}
        >
          <div className="d-flex align-items-center">
            <div className="d-flex">
              <div className="dot active"></div>
            </div>
            <span className="me-2 text-muted">
              This database shows the list of{" "}
              <span className="bold" style={{ color: "#287f71" }}>
                Attendance
              </span>
            </span>
          </div>
        </div>
        <div className="row px-2">
          <div className="col-md-6 col-12 d-none">
            <label className="form-label">
              Centre<span className="text-danger">*</span>
            </label>
            <select
              className="form-select"
              value={selectedCenter}
              onChange={handleCenterChange}
            >
              <option selected disabled>
                Select a centre
              </option>
              {centerData &&
                centerData.map((center) => (
                  <option key={center.id} value={center.id}>
                    {center.centerName}
                  </option>
                ))}
            </select>
          </div>
          <div className="col-md-3 col-12">
            <label className="form-label">
              Attendance Date<span className="text-danger">*</span>
            </label>
            <CustomDatePicker
              name="attendanceDate"
              value={selectedDate}
              onChange={handleDateChange}
              dateFormat="yyyy-MM-dd"
              placeholderText="Select a date"
            />
          </div>
          <div className="col-md-3 col-12 mb-2">
            <label className="form-label">Course</label>
            <select
              className="form-select"
              onChange={(e) => setSelectedCourse(e.target.value)}
            >
              <option value="">Select a course</option>
              {courseData &&
                courseData.map((courseId) => (
                  <option key={courseId.id} value={courseId.id}>
                    {courseId.courseNames}
                  </option>
                ))}
            </select>
          </div>

          {/* ✅ Teacher filter dropdown with role-based disable */}
          <div className="col-md-3 col-12 mb-2">
            <label className="form-label">Teacher</label>
            <select
              className="form-select"
              name="userId"
              value={filters.userId}
              disabled={isTeacher} // ✅ disable for SMS_TEACHER role
              onChange={(e) =>
                setFilters((prev) => ({ ...prev, userId: e.target.value }))
              }
            >
              <option value="" disabled>
                Select the Teacher
              </option>
              {teacherData?.map((teacher) => (
                <option key={teacher.id} value={teacher.id}>
                  {teacher.teacherNames}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-2 col-12">
            <label className="form-label">Batch</label>
            <select
              className="form-select"
              onChange={(e) => setSelectedBatch(e.target.value)}
            >
              <option value=""></option>
              {batchData &&
                batchData.map((time) => {
                  const displayTime = normalizeTime(time);
                  const valueTime =
                    time.includes("AM") || time.includes("PM")
                      ? convertTo24Hour(time)
                      : time;
                  return (
                    <option key={time} value={valueTime}>
                      {displayTime}
                    </option>
                  );
                })}
            </select>
          </div>
          <div className="col-md-1 col-12 d-flex align-items-end justify-content-end mb-3">
            <button
              className="btn btn-light btn-button btn-sm mt-3"
              onClick={fetchData}
              disabled={!selectedCenter || !selectedDate}
            >
              Search
            </button>
          </div>
        </div>
        <div className="container-fluid">
          <div className="row m-0">
            <div
              className="row"
              style={{
                backgroundColor: "#f5f7f9",
              }}
            >
              <div className="py-2 col-md-2 col-sm-3 col-12">
                <p
                  style={{
                    marginBottom: "0px",
                    fontWeight: "700",
                    fontSize: "13px",
                  }}
                >
                  Centre
                </p>
              </div>
              <div className="py-2 col-md-2 col-sm-3 col-12">
                <p
                  style={{
                    marginBottom: "0px",
                    fontWeight: "700",
                    fontSize: "13px",
                  }}
                >
                  Course
                </p>
              </div>
              <div className="py-2 col-md-2 col-sm-3 col-12">
                <p
                  style={{
                    marginBottom: "0px",
                    fontWeight: "700",
                    fontSize: "13px",
                  }}
                >
                  Class Code
                </p>
              </div>
              <div className="py-2 col-md-2 col-sm-3 col-12">
                <p
                  style={{
                    marginBottom: "0px",
                    fontWeight: "700",
                    fontSize: "13px",
                  }}
                >
                  Batch Time
                </p>
              </div>
              <div className="py-2 col-md-2 col-sm-3 col-12">
                <p
                  style={{
                    marginBottom: "0px",
                    fontWeight: "700",
                    fontSize: "13px",
                  }}
                >
                  Course Type
                </p>
              </div>
              <div className="py-2 col-md-2 col-sm-3 col-12">
                <p
                  style={{
                    marginBottom: "0px",
                    fontWeight: "700",
                    fontSize: "13px",
                  }}
                >
                  Class Listing Teacher
                </p>
              </div>
            </div>
            {attendanceData && attendanceData.length > 0 ? (
              attendanceData.map((attendanceItem, attendanceIndex) => (
                <AttendanceItem
                  key={attendanceIndex}
                  attendanceItem={attendanceItem}
                  attendanceIndex={attendanceIndex}
                  lessonData={lessonData}
                  fetchData={fetchData}
                  selectedDate={selectedDate}
                  storedScreens={storedScreens}
                  handleAttendanceChange={handleAttendanceChange}
                  handleRemarksChange={handleRemarksChange}
                  handleTemplateMessageChange={handleTemplateMessageChange}
                  handleSubmit={handleSubmit}
                  handleReplacementSuccess={handleReplacementSuccess}
                  submittingIndex={submittingIndex}
                />
              ))
            ) : (
              <div className="text-center py-3">
                <p>No Attendance Data Available</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Attendances;
